import PropTypes from 'prop-types';
import { Component } from 'react';
import { List } from 'immutable';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBanner from 'UIComponents/alert/UIBanner';
import LoadingWrapper from './LoadingWrapper';
import { loadAttributes } from '../actions/AttributeActions';
import { loadHubUsers } from '../actions/HubUsersActions';
import { loadPermissions } from '../actions/PermissionsActions';
import { loadProfile, loadProfileHubless } from '../actions/ProfileActions';
import { loadProfileOptions, loadProfileOptionsHubless } from '../actions/ProfileOptionsActions';
import BlankNameModalContainer from '../containers/BlankNameModalContainer';
import UnrecoverableError from '../components/UnrecoverableError';
import { isApplicationHubless, getIsUserImpersonated } from '../selectors/AuthSelector';
import { getUnrecoverableErrors } from '../selectors/ErrorSelector';
import { getFirstNameFromCurrentUserProfile, getLastNameFromCurrentUserProfile } from '../selectors/ProfileSelector';
import { getFetchPermissionsRequestStatus, getFetchProfileRequestStatus, getFetchProfileOptionsRequestStatus, getFetchNotificationsRequestStatus, getFetchHubUsersRequestStatus } from '../selectors/RequestStatusSelector';
import { anyRequestsFailed } from '../utils/requestUtils';
import RequestStatusTypes from '../constants/RequestStatusTypes';
import ErrorBoundary from 'settings-ui-security/components/ErrorBoundary';
import { NavMarker } from 'react-rhumb';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const loadOnce = (loader, requestStatus) => {
  if (!requestStatus || requestStatus === RequestStatusTypes.UNINITIALIZED) {
    loader();
  }
};
const UserApiFailureBanner = () => /*#__PURE__*/_jsx(View, {
  marginBlockEnd: "600",
  children: /*#__PURE__*/_jsx(UIBanner, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "failures.userApiFailure.title"
    }),
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "failures.userApiFailure.description"
      })
    })
  })
});
class UserPreferencesPage extends Component {
  componentDidMount() {
    const {
      fetchProfileRequestStatus,
      fetchProfileOptionsRequestStatus,
      fetchPermissionsRequestStatus,
      fetchHubUsersRequestStatus,
      isHubless
    } = this.props;
    if (isHubless) {
      loadOnce(this.props.loadProfileHubless, fetchProfileRequestStatus);
      loadOnce(this.props.loadProfileOptionsHubless, fetchProfileOptionsRequestStatus);
    } else {
      loadOnce(this.props.loadProfile, fetchProfileRequestStatus);
      loadOnce(this.props.loadProfileOptions, fetchProfileOptionsRequestStatus);
      loadOnce(this.props.loadPermissions, fetchPermissionsRequestStatus);
      loadOnce(this.props.loadHubUsers, fetchHubUsersRequestStatus);
    }
  }
  getBlockingRequestStatuses() {
    const {
      fetchProfileRequestStatus
    } = this.props;
    return [fetchProfileRequestStatus];
  }
  getErrorCheckRequestStatuses() {
    const {
      fetchProfileRequestStatus,
      fetchNotificationsRequestStatus
    } = this.props;
    return [fetchProfileRequestStatus, fetchNotificationsRequestStatus];
  }
  renderContent() {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'children' does not exist on type 'Readon... Remove this comment to see the full error message
      children,
      hasName,
      unrecoverableErrors,
      loadWithErrors,
      isUserImpersonated
    } = this.props;
    let isNewUser = false;
    if (document.referrer.includes('invite-user')) {
      isNewUser = true;
    }
    const showErrorState = unrecoverableErrors.size || anyRequestsFailed.apply(null, this.getErrorCheckRequestStatuses());
    if (showErrorState) {
      // ** Edge case **
      //  `loadWithErrors` allows page to load even though part of the payload is failing
      // Currently only used in `SecurityContainer`
      if (loadWithErrors) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(UserApiFailureBanner, {}), children]
        });
      }
      return /*#__PURE__*/_jsx(UnrecoverableError, {});
    }
    if (!hasName && !isUserImpersonated && !isNewUser) {
      return /*#__PURE__*/_jsx(BlankNameModalContainer, {});
    }
    return children;
  }
  render() {
    return /*#__PURE__*/_jsx(ErrorBoundary, {
      children: /*#__PURE__*/_jsx(LoadingWrapper, {
        requestStatuses: this.getBlockingRequestStatuses(),
        children: /*#__PURE__*/_jsx(NavMarker, {
          name: "UP_FRONT_REQUEST_LOADED",
          children: this.renderContent()
        })
      })
    });
  }
}
UserPreferencesPage.defaultProps = {
  loadWithErrors: false
};
UserPreferencesPage.propTypes = {
  children: PropTypes.node.isRequired,
  fetchHubUsersRequestStatus: PropTypes.string.isRequired,
  fetchNotificationsRequestStatus: PropTypes.string.isRequired,
  fetchPermissionsRequestStatus: PropTypes.string.isRequired,
  fetchProfileOptionsRequestStatus: PropTypes.string.isRequired,
  fetchProfileRequestStatus: PropTypes.string.isRequired,
  hasName: PropTypes.bool,
  isHubless: PropTypes.bool.isRequired,
  loadHubUsers: PropTypes.func.isRequired,
  loadPermissions: PropTypes.func.isRequired,
  loadProfile: PropTypes.func.isRequired,
  loadProfileHubless: PropTypes.func.isRequired,
  loadProfileOptions: PropTypes.func.isRequired,
  loadProfileOptionsHubless: PropTypes.func.isRequired,
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof List' is not assignable t... Remove this comment to see the full error message
  unrecoverableErrors: PropTypes.instanceOf(List),
  loadWithErrors: PropTypes.bool,
  isUserImpersonated: PropTypes.bool.isRequired
};
const mapStateToProps = (state, {
  params
}) => {
  return {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
    fetchHubUsersRequestStatus: getFetchHubUsersRequestStatus(state, {
      params
    }),
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
    fetchNotificationsRequestStatus: getFetchNotificationsRequestStatus(state, {
      params
    }),
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
    fetchPermissionsRequestStatus: getFetchPermissionsRequestStatus(state, {
      params
    }),
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
    fetchProfileRequestStatus: getFetchProfileRequestStatus(state, {
      params
    }),
    fetchProfileOptionsRequestStatus: getFetchProfileOptionsRequestStatus(state,
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
    {
      params
    }),
    hasName: getFirstNameFromCurrentUserProfile(state) !== null && getLastNameFromCurrentUserProfile(state) !== null,
    isHubless: isApplicationHubless(state),
    unrecoverableErrors: getUnrecoverableErrors(state),
    isUserImpersonated: getIsUserImpersonated(state)
  };
};
export default connect(mapStateToProps, {
  loadProfile,
  loadProfileHubless,
  loadPermissions,
  loadProfileOptions,
  loadProfileOptionsHubless,
  loadAttributes,
  loadHubUsers
})(UserPreferencesPage);